import React, { useState } from "react";
import "./Login.scss";
import Logo from "../../assets/Logo.png";
import Logo_Banner from "../../assets/logo_banner.png";
import Login_btn from "../../assets/login_btn.png";
import Eye_View from "../../assets/eye_view.svg";
import Eye_Hide from "../../assets/eye_hide.svg";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { webEndPoint } from "../../constant/constant";
import AlertModal from "../../components/Modals/AlertModal";
import Loader from "../../components/Loader/Loader";
import { makeRequest } from "../../services/api";
import { setItem } from "../../services/utilities";

function Login() {
  let navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  const [show, setShow] = useState(false);
  const [openModal, setOpenModal] = useState(false);
  const [errorMsg, setErrorMsg] = useState("");
  const [editmail, setEditmail] = useState(localStorage.username);
  const [editPassword, setPassword] = useState(localStorage.userpassword);
  const onSubmit = (data) => {
    if (data.remember_me === true) {
      localStorage.checkbox = data.remember_me;
      localStorage.username = data.username;
      localStorage.userpassword = data.password;
    } else {
      localStorage.checkbox = data.remember_me;
      localStorage.username = "";
      localStorage.userpassword = "";
    }
    authLogin({
      id: data.username,
      password: data.password,
    });
  };
  const authLogin = async (data) => {
    try {
      setLoading(true);
      let url = webEndPoint + "login";
      const response = await makeRequest("post", url, data);
      if (response) {
        setItem("userDetail", JSON.stringify(response));
        localStorage.setItem("users", JSON.stringify(response?.user));
        setLoading(false);
        navigate("/gemstone");
      }
    } catch (err) {
      setLoading(false);
      setErrorMsg(
        JSON.stringify(err?.alert) ||
          "Incorrect username or password. Please verify your credentials and try again.",
      );
      setOpenModal(true);
    }
  };
  const password_toggle = () => {
    setShow(!show);
  };
  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Loader loading={loading} />
      <div className="grid">
        <div className="order__left centered">
          <div className="form">
            <img class="astro_logo centered" src={Logo} alt="astrocure_logo" />
            <p className="login-header-text">Welcome To AstroCure! </p>
            <p className="login-label-text">Login</p>
            <p className="login-description-text">
              Login to access your account
            </p>
            {localStorage.checkbox === "true" ? (
              <div className="fullname-input-container-sign">
                <label className="fullname-label">
                  J-ID <span className="fullname-required">*</span>
                </label>
                <input
                  {...register("username", { required: true })}
                  type="text"
                  id="username"
                  name="username"
                  placeholder="Enter your J Id"
                  className="login_input_style"
                  value={editmail}
                  onChange={(e) => setEditmail(e.target.value)}
                  autocomplete="off"
                />
              </div>
            ) : (
              <div className="fullname-input-container-sign">
                <label className="fullname-label">
                  J-ID <span className="fullname-required">*</span>
                </label>
                <input
                  {...register("username", { required: true })}
                  type="text"
                  id="username"
                  name="username"
                  placeholder="Enter your J Id"
                  className="login_input_style"
                  autocomplete="off"
                />
              </div>
            )}
            {errors.username && <p className="alert_msg">J Id is required.</p>}
            <div className="fullname-input-container-sign">
              <label className="fullname-label">
                J-Password <span className="fullname-required">*</span>
              </label>
              {localStorage.checkbox === "true" ? (
                <input
                  {...register("password", { required: true })}
                  type={show ? "text" : "password"}
                  id="password"
                  name="password"
                  value={editPassword}
                  className="password_input_style"
                  onChange={(e) => setPassword(e.target.value)}
                  placeholder="Enter your J Password"
                  autocomplete="off"
                />
              ) : (
                <input
                  {...register("password", { required: true })}
                  type={show ? "text" : "password"}
                  id="password"
                  name="password"
                  className="password_input_style"
                  placeholder="Password"
                  autocomplete="off"
                />
              )}
              <img
                className="password_icon_view"
                src={show ? Eye_View : Eye_Hide}
                alt="eye"
                onClick={() => password_toggle()}
              />
            </div>
            {errors.password && (
              <p className="alert_msg">Password is required.</p>
            )}
            <div className="justify__space_between">
              <span>
                <input
                  type="checkbox"
                  id="remember_me"
                  name="remember_me"
                  className="rememberme-box"
                  {...register("remember_me", { required: false })}
                />
                <label for="remember_me" className="remember_me">
                  Remember Me
                </label>
                <br />
              </span>
              {/* <a href="/forgot_password" className="forgot__password">
                Forgot Password?
              </a> */}
            </div>
            <div className="fullname-input-container-sign">
              <div>
              <button type="submit" class="send_otp login__text">
                Login
              </button>
              </div>

            </div>
          </div>

          <div class="signup">
            <label className="copy_right_text">
              Copyright © 2025 Astrovidhi Private Limited All rights reserved
            </label>
          </div>
        </div>
        <div className="order__right no__overflow banner">
          <img className="banner__image" src={Logo_Banner} alt="banner" />
        </div>
      </div>
      <AlertModal open={openModal} setOpen={setOpenModal} errorMsg={errorMsg} />
    </form>
  );
}

export default Login;
